import { useAuth } from "@/context/AuthContext";
import { LogOut, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function AdminSettings() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    toast.success("Signed out.");
    navigate("/admin/login", { replace: true });
  };

  return (
    <div data-testid="page-admin-settings" className="space-y-6 max-w-2xl">
      <div
        className="rounded-2xl border p-6 md:p-8 flex items-start gap-5"
        style={{ background: "#fff", borderColor: "rgba(27,67,50,0.12)" }}
      >
        {user?.picture ? (
          <img src={user.picture} alt="" className="h-16 w-16 rounded-full object-cover" />
        ) : (
          <div
            className="h-16 w-16 rounded-full inline-flex items-center justify-center"
            style={{ background: "#C9A84C", color: "#1B4332" }}
          >
            <span className="font-serif text-xl">{(user?.name || "?").slice(0, 1)}</span>
          </div>
        )}
        <div className="min-w-0 flex-1">
          <div className="font-serif text-2xl" style={{ color: "#1B4332" }}>{user?.name}</div>
          <div className="text-sm" style={{ color: "#6E6759" }}>{user?.email}</div>
          <div className="mt-2 inline-flex items-center gap-2 text-xs px-3 py-1 rounded-full"
               style={{ background: "#FAF6EC", color: "#1B4332", border: "1px solid rgba(27,67,50,0.15)" }}
               data-testid="settings-role">
            <ShieldCheck size={12} /> {(user?.role || "super_admin").replace("_", " ")}
          </div>
        </div>
      </div>

      <div
        className="rounded-2xl border p-6 md:p-8"
        style={{ background: "#fff", borderColor: "rgba(27,67,50,0.12)" }}
      >
        <h3 className="font-serif text-xl" style={{ color: "#1B4332" }}>Session</h3>
        <p className="mt-2 text-sm leading-relaxed" style={{ color: "#2A2621" }}>
          Your sign-in cookie lasts 7 days. Sign out here to clear it immediately.
        </p>
        <button
          type="button"
          onClick={doLogout}
          className="mt-5 inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm border"
          style={{ borderColor: "#8A2A2A", color: "#8A2A2A" }}
          data-testid="settings-logout"
        >
          <LogOut size={14} /> Sign out
        </button>
      </div>

      <div
        className="rounded-2xl border p-6 md:p-8"
        style={{ background: "#FAF6EC", borderColor: "rgba(27,67,50,0.12)" }}
      >
        <h3 className="font-serif text-xl" style={{ color: "#1B4332" }}>Access</h3>
        <p className="mt-2 text-sm leading-relaxed" style={{ color: "#2A2621" }}>
          The admin portal is protected by Google Sign-In and an email allowlist. To invite another
          admin, add their Google email to the <code>ADMIN_ALLOWED_EMAILS</code> value in the
          backend environment and restart the backend.
        </p>
      </div>
    </div>
  );
}
